export const MenuItems = [
    {
        title: 'Experience',
        url: '#',
        cName : "nav-links",
    },
    {
        title: 'Skills',
        url: '#',
        cName : 'nav-links',
    },
    {
        title: 'Awards',
        url: '#',
        cName : 'nav-links',
    },
    {
        title: 'Contact',
        url: '#',
        cName : 'nav-links',
    },
    {
        title: 'Blog',
        url: '#',
        cName : 'nav-links',
    },
]
